// extracted by mini-css-extract-plugin
module.exports = {"select":"gdlSelect_select_eHc7P"};